import Toggles from "@domain/toggles/Toggles"
import CommonApiCaller from "@vibialighting/api-kit/apiCaller"
import { getURL } from "@infrastructure"

type servicesTypes = 'v2' | 'v3' | 'cms' | 'users' | 'projects' | 'masters' | ''
type restMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

class ApiCaller extends CommonApiCaller {
    static async call(service: servicesTypes, method: restMethod, route: string, payload?: any, configs?: any, subdomain = 'api.') {

        if (Toggles.isEnabled("useNewApiCaller")) {
            return super.call(service, method, route, payload, configs, subdomain)
        } else {
            const path = service ? `${service}/${route}` : route
            const url = getURL(path, subdomain)
            switch (method) {
                case 'GET':
                    const getResponse = await fetch(url, {
                        method: 'GET',
                        ...configs
                    })

                    if (this.isStatus2XX(getResponse)) {
                        return getResponse.json()
                    } else {
                        throw ({
                            ErrorCode: getResponse.status,
                            ErrorDescription: getResponse.statusText
                        })
                    }

                case 'POST':
                case 'PUT':
                    let bodyToSend = payload;
                    let headersToSend = {};

                    if (typeof payload === 'string' || payload instanceof FormData || (payload && payload.constructor && payload.constructor.name === 'FormData')) {
                        bodyToSend = payload;
                    } else {
                        bodyToSend = JSON.stringify(payload);
                        headersToSend = { 'Content-Type': 'application/json' };
                    }

                    const postResponse = await fetch(url, {
                        method,
                        headers: headersToSend,
                        body: bodyToSend,
                        ...configs
                    })
                    if (this.isStatus2XX(postResponse)) {
                        if (postResponse.status === 204) return ''
                        return postResponse.json()
                    } else {
                        throw ({
                            ErrorCode: postResponse.status,
                            ErrorDescription: postResponse.statusText
                        })
                    }
                default:
                    throw `Invalid method "${method}". Valid methods 'GET', 'PUT' or 'POST.`
            }
        }
    }
}

export default ApiCaller